module.exports = __webpack_public_path__ + "static/media/banner-clients-02.8c1e8413.jpg";